import React, { useEffect, useId, useState, useMemo } from 'react';
import FormField from '../FormField/FormField';
import SubmitButton from '../SubmitButton/SubmitButton';
import './CreateClientModal.css';

import NotificationPopup from '../NotificationPopup/NotificationPopup';
import { createPortal } from 'react-dom';
import { createClient } from '../../api/clientsApi';

const requiredFields = ['login', 'first_name', 'last_name', 'email', 'phone'];
const modifierClassesFormField = { field: 'create-client__textarea' };

const CreateClientModal = ({
  handleClose,
  isEmployeeFormOpen,
  selectedItemId,
  updateTabData,
  selectedTab,
}) => {
  const generatedId = useId();

  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [loginInvitedUser, setLoginInvitedUser] = useState('');

  const [formData, setFormData] = useState({
    login: '',
    first_name: '',
    last_name: '',
    patronymic: '',
    email: '',
    phone: '',
    password: '',
    workplace_ids: [],
    comment: '',
    errors: {},
  });



  // --- поля формы ---
  const fieldLabels = useMemo(
    () => [
      { key: 'login', label: 'Логин', type: 'text' },
      { key: 'first_name', label: 'Имя', type: 'text' },
      { key: 'last_name', label: 'Фамилия', type: 'text' },
      { key: 'patronymic', label: 'Отчество', type: 'text' },
      { key: 'email', label: 'Email', type: 'email' },
      { key: 'phone', label: 'Телефон', type: 'text' },
      { key: 'password', label: 'Пароль', type: 'password' },

      { key: 'comment', label: 'Комментарий', type: 'textarea' },
    ],
    []
  );

  // --- валидация ---
  const validateField = (name, value) => {
    if (requiredFields.includes(name) && (!value || value.length === 0)) return 'Поле обязательно';
    if (name === 'email' && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) return 'Некорректный email';
    }
    return null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      errors: { ...prev.errors, [name]: validateField(name, value) },
    }));
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    Object.keys(formData).forEach((field) => {
      if (field === 'errors') return;
      const error = validateField(field, formData[field]);
      if (error) {
        errors[field] = error;
        isValid = false;
      }
    });

    setFormData((prev) => ({ ...prev, errors }));
    return isValid;
  };

  // --- submit ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const dataToSend = { ...formData, organisation_id: selectedItemId, type_id: 1 };
      await createClient(dataToSend);

      setFormData({
        login: '',
        first_name: '',
        last_name: '',
        patronymic: '',
        email: '',
        phone: '',
        password: '',
        workplace_ids: [],
        comment: '',
        errors: {},
      });

      setLoginInvitedUser(formData.login);
      setIsNotificationVisible(true);
      await updateTabData(selectedTab);
      handleClose();
    } catch (error) {
      const rawMessage = error?.data?.message || 'Ошибка приглашения клиента';
      setFormData((prev) => ({ ...prev, errors: { commonErr: rawMessage } }));
    }
  };

  useEffect(() => {
    if (isNotificationVisible) {
      const timer = setTimeout(() => {
        setIsNotificationVisible(false);
        setLoginInvitedUser('');
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [isNotificationVisible]);

  return (
    <>
      <div
        className={`overlay ${isEmployeeFormOpen ? 'show' : 'hide'}`}
        onClick={handleClose}
      />
      <section className={`create-client ${isEmployeeFormOpen ? 'show' : 'hide'}`}>
        <div className='create-client__form'>
          <div className='create-client__header'>
            <h2 className='create-client__header-title'>Добавить клиента</h2>
            <SubmitButton
              className='create-client__save-button'
              text='+ Клиента'
              type='submit'
              onClick={handleSubmit}
            />
            <button onClick={handleClose} className='profile__close-btn' />
            {formData.errors.commonErr && (
              <span className='commonErr'>{formData.errors.commonErr}</span>
            )}
          </div>
          <form className='create-client__form-container'>
            {fieldLabels.map(({ key, label, type, options, placeholder, isMulti }) => (
              <FormField
                key={`${key}-${generatedId}`}
                label={label}
                name={key}
                value={formData[key] || ''}
                onChange={handleChange}
                error={formData.errors[key]}
                selectTagErr={formData?.errors?.selectTagErr || []}
                required={requiredFields.includes(key)}
                type={type}
                options={options}
                placeholder={placeholder}
                modifierClassesFormField={modifierClassesFormField}
                isMulti={isMulti}
              />
            ))}
          </form>
        </div>
      </section>
      {isNotificationVisible &&
        createPortal(
          <NotificationPopup
            duration={5000}
            message={`Приглашение отправлено пользователю с логином ${loginInvitedUser}`}
            onClose={() => setIsNotificationVisible(false)}
          />,
          document.body
        )}
    </>
  );
};

export default CreateClientModal;
